var r;function e(){if(r)return r;try{r=new Function("return import(arguments[0]);")}catch{r=n=>import(/* @vite-ignore */ n)}return r}function t(n){return e()(n)}export{t as a};
//# sourceMappingURL=chunk-IEWAPLTP.js.map